import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetTotalSummaryCtrl = function (fn, er, state, token, ids) {

	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};

	var data = {
		abi: state.abi,
		codPos: state.codepv,
		pos: state.codpos,
		day: state.selectedDay,
		maxGrossCalculated: state.maxamount,
		maxGrossDeclared: state.maxamountnet,
		minGrossCalculated: state.minamount,
		minGrossDeclared: state.minamountnet,
		month: state.selectedMonthYear,
		orderBy: "",
		page: state.currentPage
	};

	axios
		.post(ApiConfig.url.GET_TOTAL_SUMMARY, data, config)
		.then(function (result) {
			fn(result.data)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetTotalSummaryCtrl };